import React from "react";
import { Col, Grid, Row } from "react-bootstrap";
import figAddLicenses from "./img/add_licenses.png";
import figSendActivationMail from "./img/send_activation_mail.png";
import figStep1 from "./img/step1.png";
import figStep2 from "./img/step2.png";
import figStep3 from "./img/step3.png";
import figStep4 from "./img/step4.png";
import figStep5 from "./img/step5.png";
import { WORK_PLACE_ENDPOINT } from "./utils/constants";

interface Props {
  clientName: string;
  scopes: string;
}

export default function Manual(props: Props) {
  return (
    <Grid>
      <div className="rsi-title">
        <b>Step 1:</b> Login to Google Workspace Admin Console
      </div>
      <Col sm={12} className="border border-secondary">
        <Row>
          <p>
            URL:{" "}
            <a href="https://admin.google.com" target="_blank">
              https://admin.google.com
          </a>{" "}
          and login with Google Workspace administrator’s account
          </p>
        </Row>
        <img className="manualFigure" src={figStep1} />
        <Row>Select 'Security' in this screen</Row>
      </Col>
      <div className="rsi-title">
        <b>Step 2:</b> In 'Security'. Select 'API controls'
      </div>
      <Col sm={12} className="border border-secondary">
        <img className="manualFigure" src={figStep2} />
      </Col>
      <div className="rsi-title">
        <b>Step 3:</b> In 'API controls'. Click 'MANAGE DOMAIN WIDE DELEGATION'
      </div>
      <Col sm={12} className="border border-secondary">
        <img className="manualFigure" src={figStep3} />
      </Col>
      <div className="rsi-title">
        <b>Step 4:</b> In 'Domain-wide Delegation'. Click 'Add new'
      </div>
      <Col sm={12} className="border border-secondary">
        <img className="manualFigure" src={figStep4} />
      </Col>
      <div className="rsi-title">
        <b>Step 5:</b> In 'Add a new client ID', input Client ID and OAuth scopes. Press 'AUTHORIZE'.
      </div>
      <Col sm={12} className="border border-secondary">
        <Row>
          <p>
            For Client ID and OAuth scopes, please copy and paste the following:
          </p>
          <h4>Client ID:</h4>
          <Col
            sm={12}
            id="clientName"
            style={{ marginBottom: "10px", wordWrap: "break-word" }}
          >
            {props.clientName}
          </Col>
          <h4>OAuth scopes:</h4>
          <Col sm={10} id="apiScopes" style={{ wordWrap: "break-word" }}>
            {props.scopes}
          </Col>
        </Row>
        <img className="manualFigure" src={figStep5} />
      </Col>
      <Row />
    </Grid>
  );
}

export function AfterInstruction() {
  return (
    <div style={{ marginBottom: "300px" }}>
      <h4>
        User synchronization is runnning...
        <br />
        Please do the following things as needed
      </h4>

      <div className="rsi-title">Assign licenses to synchronized users</div>
      <Col sm={12} className="border border-secondary">
        <Row>
          Go to{" "}
          <a
            href={WORK_PLACE_ENDPOINT + "/portal/user-permission-mgmt.html"}
            id="linkUserLicenseManagement"
          >
            User License Management Page
          </a>{" "}
          and assign licenses.
        </Row>
        <Col sm={12} className="border border-secondary">
          <img className="manualFigure" src={figAddLicenses} />
        </Col>
      </Col>
      <div className="rsi-title">Send activation email to synchronized users</div>
      <Col sm={12} className="border border-secondary">
        <Row>
          Go to{" "}
          <a href={WORK_PLACE_ENDPOINT + "/portal/usrmgmt.html"} id="linkUserManagement">
            User Management Page
          </a>{" "}
          and send activation email.
        </Row>
        <Col sm={12} className="border border-secondary">
          <img className="manualFigure" src={figSendActivationMail} />
        </Col>
      </Col>
    </div>
  );
}
